import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useCuentas, useCrearCuenta, useCambiarRolCuenta, useEliminarCuenta } from '../../hooks/useCuentas';
import { AccountTable } from '../../components/admin/AccountTable';
import { Button } from '../../components/shared/Button';
import { Input } from '../../components/shared/Input';
import { Spinner } from '../../components/shared/Spinner';
import { useToast } from '../../components/shared/Toast';
import { NuevaCuenta } from '../../types/identidad';

/** US-08 — visible solo para Administrador (AdminSidebar ya oculta el enlace; el backend re-valida con 403). */
export function CuentasAdminPage() {
  const { data: cuentas, isLoading } = useCuentas();
  const crear = useCrearCuenta();
  const cambiarRol = useCambiarRolCuenta();
  const eliminar = useEliminarCuenta();
  const { mostrarError, mostrarExito } = useToast();
  const [mostrarForm, setMostrarForm] = useState(false);

  const { register, handleSubmit, reset } = useForm<NuevaCuenta>({ defaultValues: { rol: 'Empleado' } });

  const crearCuenta = (datos: NuevaCuenta) => {
    crear.mutate(datos, {
      onSuccess: () => {
        mostrarExito('Cuenta creada');
        reset();
        setMostrarForm(false);
      },
      onError: (error) => mostrarError((error as Error).message),
    });
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="flex justify-between items-center">
        <div className="text-[13px] text-admin-ink-muted">{cuentas?.length ?? 0} cuentas administrativas</div>
        <Button onClick={() => setMostrarForm((v) => !v)}>{mostrarForm ? 'Cancelar' : 'Nueva cuenta'}</Button>
      </div>

      {mostrarForm && (
        <form onSubmit={handleSubmit(crearCuenta)} className="bg-white border border-admin-border rounded-xl p-6 flex flex-col gap-4 max-w-md">
          <Input label="Usuario (correo)" placeholder="empleado@sacrafts.com" {...register('usuario', { required: true })} />
          <Input label="Nombre" {...register('nombre', { required: true })} />
          <Input label="Apellido" {...register('apellido', { required: true })} />
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-bold uppercase tracking-wide text-admin-ink-muted">Rol</label>
            <select {...register('rol')} className="border border-admin-border rounded-md px-3.5 py-2.5 text-sm">
              <option value="Empleado">Empleado</option>
              <option value="Administrador">Administrador</option>
            </select>
          </div>
          <p className="text-xs text-admin-ink-muted leading-relaxed">
            Cognito le enviará un correo de invitación con una contraseña temporal — no
            necesitas comunicársela vos mismo.
          </p>
          <Button type="submit" disabled={crear.isPending}>
            {crear.isPending ? 'Creando…' : 'Crear cuenta'}
          </Button>
        </form>
      )}

      {isLoading ? (
        <Spinner />
      ) : (
        <AccountTable
          cuentas={cuentas ?? []}
          onCambiarRol={(id, rol) =>
            cambiarRol.mutate({ id, rol }, { onError: (e) => mostrarError((e as Error).message) })
          }
          onEliminar={(id) =>
            eliminar.mutate(id, {
              onSuccess: () => mostrarExito('Cuenta eliminada'),
              onError: (e) => mostrarError((e as Error).message),
            })
          }
        />
      )}
    </div>
  );
}
